<settings-contact [allowEdit]="allowEdit" [structureId]="structureId" [preferenceContact$]="preferenceContact$" *ngIf="showContact">
</settings-contact>

<settings-notifications
	[allowEdit]="allowEdit"
	[structureId]="structureId"
	[preferencesNotifications$]="preferencesNotifications$"
></settings-notifications>

<settings-releve-affaire
	[allowEdit]="allowEdit"
	[structureId]="structureId"
	[preferenceReleveAffaires$]="preferencesReleveAffaires$"
></settings-releve-affaire>

<settings-cheque [allowEdit]="allowEdit" [structureId]="structureId" [preferencesCheques$]="preferencesCheques$"></settings-cheque>

<settings-mode-reception
	[allowEdit]="allowEdit"
	[structureId]="structureId"
	[modesReception$]="modesReception$"
	[preferenceModeReception$]="preferenceModeReception$"
></settings-mode-reception>

<rib-compte-pro
	[fromBO]="!allowEdit"
	[structure]="raisonSociale"
	[deviseCompte]="devise"
	[coordonneeBancaire]="coordonneeBancaire"
	[compteId]="compteId"
	(reloadCurrentComptes)="onReloadCurrentComptes()"
></rib-compte-pro>
